import React from "react"
import Membership from "../Components/Membership/Membership"

export default () => {
    
    return <div>
        <Membership />
    </div>
}